<script setup lang="ts">
import ListHeader from '@/components/GpsTrackerSetting/ListHeader.vue';
import ListRow from '@/components/GpsTrackerSetting/ListRow.vue';
import getGpsTrackerSettingResponse from '@/types/responses/getGpsTrackerSetting'

const props = defineProps<{
  isLoading: boolean
  gpsTrackerSettings: getGpsTrackerSettingResponse[]
  showDeleteButton: boolean
}>()

const emit = defineEmits<{
  (e: 'delete', id: number): void
}>()

function onDelete(id: number) {
  emit('delete', id)
}
</script>

<template>
  <div class="mb-2">
    <div class="list list-scrollbar">
      <v-table>
        <ListHeader />
        <ListRow
          v-for="gpsTrackerSetting in gpsTrackerSettings"
          :key="gpsTrackerSetting.id"
          :gpsTrackerSetting="gpsTrackerSetting"
          :showDeleteButton="props.showDeleteButton"
          @delete="onDelete"
        />
      </v-table>
    </div>
  </div>
</template>
